// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__383P3","spin":"Spinner_spin__2dMX1"};